import { useEffect, useRef } from 'react';
import { useCardHeight } from '../context/CardHeightContext';

export function useCardMeasure() {
  const ref = useRef<HTMLDivElement>(null);
  const { updateMaxHeight } = useCardHeight();

  useEffect(() => {
    const measureHeight = () => {
      if (ref.current) {
        const height = ref.current.scrollHeight;
        updateMaxHeight(height);
      }
    };

    measureHeight();
    window.addEventListener('resize', measureHeight);
    
    return () => window.removeEventListener('resize', measureHeight);
  }, [updateMaxHeight]);

  return ref;
}